/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

interface Config {
    BASE: string;
    VERSION: string;
    CLIENT: 'fetch' | 'xhr';
    WITH_CREDENTIALS: boolean;
    TOKEN: string;
}

export const OpenAPI: Config = {
    BASE: '/',
    VERSION: '1.0.0',
    CLIENT: 'fetch',
    WITH_CREDENTIALS: false,
    TOKEN: '',
};